import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import PolarisCredentialsForm from "./PolarisCredentialsForm";
import PolarisConfigListing from "./PolarisConfigListing";

export default function PolarisPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={PolarisCredentialsForm}
      PullConfigListingView={PolarisConfigListing}
    />
  );
}
